import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pm",
  "use": "icon-pm-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-pm\">\r\n<path d=\"M110.6,49.4l-46-23.2L78.8,8.9c0.7-0.9,2-1.2,3-0.6l41,21.9c1.4,0.7,1.7,2.5,0.7,3.7L110.6,49.4L110.6,49.4z M50.2,8.9\r\n\tl13.6,17.3L18.2,49.4l-13.7-16c-1-1.2-0.7-3,0.7-3.8L47.2,8.2C48.2,7.7,49.5,8,50.2,8.9z M63.1,71.3l-7.8,22\r\n\tc-0.2,0.5-0.8,0.8-1.3,0.5L11.3,71.9c-0.7-0.4-1-1.2-0.8-1.9l7.7-20.5L63.1,71.3L63.1,71.3z M62.8,79.9v40.4c0,0.5-0.6,0.9-1,0.7\r\n\tL16.8,99.8c-0.9-0.4-1.4-1.3-1.4-2.2l0.1-19.3c0-0.6,0.6-1,1.2-0.7L55,97.4c0.7,0.4,1.6,0,1.8-0.7L62.8,79.9z M73.1,93.5l-7.5-22.2\r\n\tl45.1-21.8l8.6,20.2c0.3,0.8,0,1.6-0.8,2L73.9,93.8C73.5,94,73.2,93.8,73.1,93.5z M113.1,97.8c0,0.8-0.5,1.5-1.2,1.9l-45,21.2\r\n\tc-0.5,0.2-1-0.1-1-0.7l0-40.4l5.6,17c0.2,0.6,0.9,0.8,1.4,0.6l38.8-19.6c0.7-0.3,1.5,0.2,1.5,0.9L113.1,97.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pm.svg
// module id = jKg0
// module chunks = 164